'use strict';

import $ from 'jquery';
import 'jquery-match-height';
import ListingFilter from '../../molecules/listing-filter/listing-filter';

export default class EventsListing {
  constructor() {
    let $Listing = $('.events-listing');
    let $eventFilters = $('.events-listing__filters', $Listing);
    let $eventCards = $('.events-listing__item');


    let eventFilters = new ListingFilter($Listing);


    $eventCards.matchHeight();

  }
}
